"use client";

import Navbar from "./Navbar";
import Footer from "./Footer";
import dynamic from "next/dynamic";

const MobileBottomBar = dynamic(() => import("./MobileBottomBar").then(mod => mod.MobileBottomBar), {
    ssr: false
});

const CartDrawer = dynamic(() => import("@/components/client/checkout/cart/CartDrawer").then(mod => mod.CartDrawer), {
    ssr: false
});

export default function ClientLayout({ children }: { children: React.ReactNode }) {
    return (
        <div className="pb-8 md:pb-0">
            <Navbar />
            <CartDrawer />
            {children}
            <Footer />
            <MobileBottomBar />
        </div>
    )
}